// extracted by css-extract-rspack-plugin
export default {"container":"Ay4cdWB_vk4JwrX3","checkbox":"i8hrE_v1UQ4C5Fqv"};